import SectionHeader from "@/components/SectionHeader";
import { SimpleReveal } from '@/hooks/useSimpleAnimation';
import { useNavigate } from "react-router-dom";
import OptimizedImage from "@/components/OptimizedImage";
import { RainbowButton } from "@/components/ui/rainbow-button";
import { useHomeData } from '../../hooks/useHomeData';
export const HomeAboutSection = () => {
  const navigate = useNavigate();
  const {
    about
  } = useHomeData();
  return <section id="about" className="relative section-spacing font-inter overflow-hidden bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <SimpleReveal>
          <div className="text-center mb-12">
            <SectionHeader title={about.title} subtitle={about.subtitle} className="mb-6" />
            <p className="text-section-description max-w-4xl mx-auto text-center">
              {about.description}
            </p>
          </div>
        </SimpleReveal>
        
        <SimpleReveal delay={200}>
          <div className="grid gap-8 lg:grid-cols-12 lg:gap-12 h-auto items-center max-w-7xl mx-auto">
            <div className="lg:col-span-5">
              <OptimizedImage src={about.imageUrl} alt={about.imageAlt} className="w-full h-[280px] lg:h-[400px] rounded-xl object-cover" sizes="(min-width: 1024px) 42vw, 100vw" />
            </div>
            
            <div className="lg:col-span-7">
              <div className="space-y-6 text-center lg:text-left">
                <h3 className="text-card-title text-foreground">
                  {about.content.heading}
                </h3>
                <p className="text-body text-neutral-700">
                  {about.content.description}
                </p>
                <div className="pt-4 flex justify-center lg:justify-start">
                  <RainbowButton onClick={() => navigate(about.ctaRoute)} className="h-11 px-8 text-base lg:text-lg hover:scale-105 transform transition-transform duration-300">
                    {about.ctaText}
                  </RainbowButton>
                </div>
              </div>
            </div>
          </div>
        </SimpleReveal>
      </div>
    </section>;
};